/**
 * Eine fremde Pause im Hintergrund sofort dem Server melden.
 * (27.10.2026, Ticket 3369)
 *
 * Nach einem Telefonat stand die Tagesaufnahme still auf Pause; iOS gibt
 * das Mikrofon im Hintergrund nicht zurück, und die einzige Warnung kam
 * nach rund 15 Minuten. Hier meldet die App den Anlass, der Server schickt
 * nach kurzer Frist einen Push (server/aufnahme-pause-push.ts).
 *
 * ⚠️ Nur die FREMDE Pause und nur im Hintergrund: Im Vordergrund sieht der
 *    Mensch die Pause selbst, eine eigene Pause (Vorlesen, Knopf) ist gewollt.
 * ⚠️ Endet die Pause (fortgesetzt, beendet, Fehler), wird das gemeldet —
 *    dann geht der Push nicht mehr hinaus, falls seine Frist noch läuft.
 * ⚠️ Nur eine Kennung, kein Inhalt.
 */

/** Die gemeldete Pause, die noch nicht vorbei ist. */
let offen: string | null = null;

/** Nur für Tests. */
export function _pausePushVergessen(): void {
  offen = null;
}

function neueKennung(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

function sende(pause: string, pausiert: boolean): void {
  try {
    void fetch("/api/recorder/pause-fremd", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      keepalive: true,
      body: JSON.stringify({ pause, pausiert }),
    }).catch(() => undefined);
  } catch {
    /* Eine Meldung ist nie wichtiger als die Aufnahme. */
  }
}

/**
 * Bei jedem Zustandswechsel der Tagesaufnahme rufen. Gibt `true` zurück,
 * wenn eben eine neue Pause gemeldet wurde. Wirft nie.
 */
export function meldePauseFuerPush(
  fremdePause: boolean,
  zustand: string,
  hintergrund: boolean,
): boolean {
  if (offen && zustand !== "paused") {
    sende(offen, false);
    offen = null;
    return false;
  }
  if (!fremdePause || !hintergrund || offen) return false;
  offen = neueKennung();
  sende(offen, true);
  return true;
}
